// start:ng42.barrel
import './transport-reports.component';
// end:ng42.barrel

